(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory((function webpackLoadOptionalExternalModule() { try { return require("bufferutil"); } catch(e) {} }()), (function webpackLoadOptionalExternalModule() { try { return require("utf-8-validate"); } catch(e) {} }()));
	else if(typeof define === 'function' && define.amd)
		define(["bufferutil", "utf-8-validate"], factory);
	else if(typeof exports === 'object')
		exports["MockStompBroker"] = factory((function webpackLoadOptionalExternalModule() { try { return require("bufferutil"); } catch(e) {} }()), (function webpackLoadOptionalExternalModule() { try { return require("utf-8-validate"); } catch(e) {} }()));
	else
		root["MockStompBroker"] = factory(root["bufferutil"], root["utf-8-validate"]);
})(global, function(__WEBPACK_EXTERNAL_MODULE__47__, __WEBPACK_EXTERNAL_MODULE__49__) {
return 